<template>
  <div>
    <div class="catagories-btns">
      <ul class="list-inline m-0">
        <li>
          <b-button
            block
            class="mb-2 box-shadow dis"
            :disabled="checkSalespersonStatus || state.system.isOffline"
            @click="openSalePerson()"
            v-shortkey.once="['ctrl', '1']"
            @shortkey="openSalePersonShortkey()"
            :title="checkSalespersonStatus == false ? 'ctrl+1' : ''"
            id="category-salesperson"
            >Salesperson</b-button
          >
        </li>
        <!-- <li>
          <button
            type="button"
            class="btn btn-grey btn-block mb-2 dis"
            v-b-modal.bill-remark
            :disabled="(parseInt(this.state.billing.total_qty) == 0)"
          >
            <span v-if="form.remark ==''">Bill Level Remark</span>
            <span v-else>Edit Remark</span>
          </button>
          <b-modal id="bill-remark" size="md" hide-footer centered title="Bill Level Remark">
            <b-form @submit.prevent="saveRemarks">
              <b-form-textarea
                placeholder="Add remark... "
                id="remark"
                aria-describedby="remark-validation"
                cols="30"
                rows="5"
                autofocus
                v-model="$v.form.remark.$model"
                :state="$v.form.remark.$dirty ? !$v.form.remark.$error : null"
              ></b-form-textarea>
              <b-form-invalid-feedback id="remark-validation">Please enter your remark</b-form-invalid-feedback>

              <div class="text-right">
                <b-button
                  class="grey-btn mt-3"
                  variant="success"
                  type="submit"
                  :disabled="$v.form.$invalid || $loading == true"
                >
                  <span v-if="$loading == false">Submit</span>
                  <b-spinner small v-if="$loading == true"></b-spinner>
                </b-button>
              </div>
            </b-form>
          </b-modal>
        </li>-->
        <li>
          <b-button
            class="mb-2 box-shadow"
            block
            @click="$router.push('../held-bill')"
            :disabled="
              state.billing.billing.hold_bill_count == 0 ||
                refundMode ||
                orderPos
            "
            v-shortkey="['ctrl', '2']"
            @shortkey="showHeldBillShortkey"
            :title="state.billing.billing.hold_bill_count != 0 ? 'ctrl+2' : ''"
            id="category-held-bills"
          >
            View Held Bills &nbsp;
            <b-badge variant="dark">
              {{ state.billing.billing.hold_bill_count }}
            </b-badge>
          </b-button>
        </li>
        <li>
          <b-button
            @click="showHoldBill"
            block
            class="mb-2 box-shadow"
            :disabled="checkHoldBill || refundMode || orderPos"
            v-shortkey="['ctrl', '3']"
            @shortkey="checkHoldBillShortkey"
            :title="checkHoldBill == false ? 'ctrl+3' : ''"
            id="category-hold-bill"
            >Hold Bill</b-button
          >
          <b-modal
            id="hold-bill"
            size="sm"
            hide-footer
            hide-header
            centered
            no-close-on-esc
            no-close-on-backdrop
          >
            <p class="fs-14 d-flex title">
              <img src="../assets/images/icon_notif.svg" alt class="mr-2" />
              Hold Bill
            </p>
            <p class="pt-2" v-text="msg.HOLDBILL_MESSAGE"></p>

            <div class="d-flex pt-4">
              <!-- <b-button
              block
              class="mr-1"
              @click="$bvModal.hide('hold-bill')"
              v-shortkey="['esc']"
              @shortkey="$bvModal.hide('hold-bill')"
            >Cancel</b-button> -->
              <b-button
                class="mr-1"
                @click="$bvModal.hide('hold-bill')"
                v-shortkey="['esc']"
                @shortkey="$bvModal.hide('hold-bill')"
                id="cancel-hold-bill"
                :disabled="$loading"
              >
                Cancel
              </b-button>
              <b-button
                variant="primary"
                class="ml-1"
                block
                @click="putHoldBill"
                :disabled="$loading"
                v-shortkey="['enter']"
                @shortkey="putHoldBill"
                id="put-hold-bill"
              >
                <span v-if="$loading == false">Hold Bill</span>
                <b-spinner small v-if="$loading == true"></b-spinner>
              </b-button>
            </div>
          </b-modal>
        </li>
        <li>
          <b-button
            block
            class="mb-2 box-shadow"
            :disabled="
              checkCart || state.system.isOffline || !applyPromotionBtn
            "
            @click="applyPromotions"
            id="category-promotions"
            >Apply Promotions</b-button
          >
        </li>
        <li>
          <b-button
            variant="danger"
            block
            class="mb-2 box-shadow"
            @click="removeDiscount"
            v-shortkey.once="['ctrl', '5']"
            :disabled="checkManualDiscount"
            id="clear-bill-discount"
            v-if="isManualDiscountApplied"
            >Clear Bill Discount</b-button
          >
          <b-button
            block
            class="mb-2 box-shadow"
            @click="openManualDiscountModal"
            v-shortkey.once="['ctrl', '5']"
            :title="checkManualDiscount == false ? 'ctrl+5' : ''"
            @shortkey="openManualDiscountModalShortkey"
            :disabled="checkManualDiscount"
            v-if="!isManualDiscountApplied"
            id="category-apply-discount"
            >Apply Manual Discount</b-button
          >

          <manual-discount
            :open="openMDBox"
            @close-manual-discount="closeManualDiscountModal"
            :bill_type="'BILL_LEVEL'"
            :pdata="''"
          ></manual-discount>
        </li>
        <li>
          <b-button
            type="button"
            block
            class="mb-2"
            style="font-weight: 300"
            @click="openCarryBags"
            :disabled="
              state.system.settings.cart.carry_bag.status == 0 || refundMode
            "
            v-shortkey="['ctrl', '6']"
            :title="
              state.system.settings.cart.carry_bag.status == 0 ? '' : 'ctrl+6'
            "
            @shortkey="openCarryBagShortkey"
            id="category-add-carrybags"
          >
            <span v-if="state.billing.billing.carry_bag_qty_total >= 1"
              >Added</span
            >
            <span v-else>Add</span> Carry Bags &nbsp;
            <b-badge variant="dark">
              {{ state.billing.billing.carry_bag_qty_total }}
            </b-badge>
            <!--  <span v-if="bagQty >= 1">Added</span>
            <span v-else>Add</span> Carry Bags &nbsp;
            <b-badge variant="dark">{{bagQty}}</b-badge>-->
          </b-button>
          <carry-bags
            :open="openBox"
            :carryBags="carryBags"
            :isActive="checkCarryBagCart"
            @close-carry="closeCarryBagModal"
          ></carry-bags>
        </li>
      </ul>
    </div>
    <div v-shortkey.foucus="['ctrl', '4']" class="clearfix"></div>
    <message-box
      :open="error"
      @close-message="flushError"
      :message="errorMsg"
    ></message-box>
    <!-- <alert-popup message="You are unauthorized !" type="success" ></alert-popup> -->
  </div>
</template>

<script>
import Loading from "../components/Loading";
import axios from "axios";
import { mapState } from "vuex";
import AlertPopup from "../components/AlertPopup";
import CarryBags from "../components/CarryBags";
import * as msg from "../message";
import ManualDiscount from "../components/ManualDiscount";
import MessageBox from "./MessageBox";
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import * as helper from "../helper";
export default {
  name: "category-buttons",
  mixins: [validationMixin],
  components: {
    AlertPopup,
    CarryBags,
    ManualDiscount,
    MessageBox,
  },
  props: {
    salesPerson: true,
  },
  data() {
    return {
      openBox: false,
      openMDBox: false,
      isShow: false,
      carryBags: "",
      bagQty: 0,
      error: false,
      errorMsg: {
        btnText: "",
        text: "",
        type: "",
      },
      // holdBillStatus: true,
      isVisible: false,
      isActive: true,
      form: {
        remark: "",
      },
    };
  },
  validations: {
    form: {
      remark: {
        required,
        minLength: minLength(3),
      },
    },
  },
  created() {
    // this.holdBill =
  },
  mounted() {
    this.form.remark = this.state.billing.billing.remark;
    this.checkCarryBagQty;
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    checkHoldBill() {
      let check = true;
      this.state.system.settings.cart_menu.map((item) => {
        if (item.name == "hold_bill" && item.status == 1) {
          if (this.state.billing.billing.total_qty != 0) {
            check = false;
          }
        }
      });
      return check;
    },
    checkRecallBill() {
      let check = true;
      this.state.system.settings.cart_menu.map((item) => {
        if (item.name == "recall_bill") {
          check = false;
        }
      });
      return check;
    },
    checkCarryBag() {
      let check = true;
      this.state.system.settings.cart_menu.map((item) => {
        if (item.name == "carry_bag" && item.status == 1) {
          check = false;
        }
      });
      return check;
    },
    checkManualDiscount() {
      let check = true;
      if (
        this.state.system.settings.offer.manual_discount.status == 1 &&
        parseInt(this.state.billing.billing.total_qty) != 0
      ) {
        check = false;
      }
      return check;
    },

    checkCarryBagQty() {
      let total = 0;
      let bagQty = [];
      if (this.state.billing.billing.cart != "") {
        this.state.billing.billing.cart.bags.map((item) => {
          this.bagQty += parseFloat(item.Qty);
        });
        return bagQty;
      }
    },
    checkCarryBagCart() {
      let check = true;
      if (this.carryBags.length > 0) {
        this.carryBags.map((item) => {
          if (item.Qty > 0) {
            this.isActive = false;
            check = false;
          }
        });
        return check;
      }
    },
    checkSalespersonStatus() {
      let check = true;
      // this.state.system.settings.cart_menu.map((item) => {
      if (
        this.$store.getters["system/salesPersonActive"] &&
        this.state.billing.billing.cart != "" &&
        this.state.billing.billing.cart.data.length != 0
      )
        check = false;

      // });
      return check;
    },
    checkCart() {
      let check = true;
      if (parseInt(this.state.billing.billing.total_qty) != 0) {
        check = false;
      }
      return check;
    },
    refundMode() {
      let check = false;
      if (this.state.billing.billing.refund_mode) {
        check = true;
      }
      return check;
    },
    isManualDiscountApplied() {
      let check = false;
      if (this.state.billing.billing.cart.hasOwnProperty("bill_summary"))
        this.state.billing.billing.cart.bill_summary.forEach((summary) => {
          if (summary.name == "manual_discount")
            summary.type.forEach((item) => {
              if (item.name == "bill_level") check = true;
            });
        });
      return check;
    },
    msg() {
      return msg;
    },
    applyPromotionBtn() {
      return this.state.system.settings.cart.enable_promotion.status;
    },
    orderPos() {
      return this.state.billing.billing.billing_mode == "order";
    },
  },
  methods: {
    removeDiscount() {
      this.$loading = true;
      let postData = {
        store_id: this.state.sessions.user.store_id,
        manual_discount_basis: "",
        remove_discount: "1",
        trans_from: this.state.system.trans_from,
        api_token: this.state.sessions.user.api_token,
        manual_discount_factor: "",
        url: "/manual-discount",
        cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
          "gstin"
        )
          ? this.state.billing.billing.customer.data.gstin
          : "",
      };

      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(data.url, data)
        .then((res) => {
          this.$store.dispatch("billing/cartDetails").then(() => {
            this.$loading = false;

            let alertData = {
              message: "Bill level " + msg.REMOVED_MANUAL_DISCOUNT,
              type: "success",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          });
        })
        .catch((err) => {
          this.$loading = false;
          // console.log(err.response);
        });
    },
    showHoldBill() {
      this.$bvModal.show("hold-bill");
      if (
        this.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
        this.state.system.settings.vendor_app_menu.offline.status == 1
      ) {
        helper.getOrderId();
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showSupervisorPopup() {
      console.log("Cool");
    },
    openSalePerson: function() {
      if (this.state.billing.billing.salesPerson.data.length == 0) {
        this.$loading = true;
        let productData = {
          c_id: "",
          api_token: this.state.sessions.user.api_token,
          store_id: this.state.sessions.user.store_id,
          vu_id: this.state.sessions.user.vu_id,
          trans_from: this.state.system.trans_from,
          // udidtoken: this.state.system.trans_from
          url: "/vendor/get-salesman",
        };
        let data = Object.assign(
          productData,
          this.essentialsData,
          this.customerData
        );
        axios
          .post(productData.url, data)
          .then((response) => {
            this.$loading = false;
            // this.salesPersons = response.data.data;
            this.$store.commit("billing/salesPersons", response.data.data);
            this.state.billing.billing.salesPerson.selected = "";
            if (response.data.data.length != 0) {
              this.$emit("show-salesp");
            } else if (response.data.data.length == 0) {
              this.error = true;
              this.errorMsg.text = msg.NO_SALESPERSON;
              this.errorMsg.btnText = "Continue";
              this.errorMsg.type = "salesPerson";
            }
          })
          .catch((err) => {
            this.$loading = false;
          });
      } else if (this.state.billing.billing.salesPerson.data.length != 0) {
        this.$emit("show-salesp");
      }
    },
    flushError(val) {
      this.error = val;
      this.errorMsg = {
        btnText: "",
        text: "",
        type: "",
      };
    },
    openSalePersonShortkey: function() {
      this.state.system.settings.cart_menu.map((item) => {
        if (item.name == "assign_salesman" && item.status == 1) {
          if (this.state.billing.billing.cart.data.length != 0) {
            this.openSalePerson();
          }
          // else {
          //   this.$emit("hide-salesp");
          // }
        }
      });
    },
    getCarryBags() {
      this.$refs["carry-bags"].show();
    },
    openManualDiscountModal() {
      this.openMDBox = true;
    },
    openManualDiscountModalShortkey() {
      if (
        this.state.system.settings.offer.manual_discount.status == 1 &&
        parseInt(this.state.billing.billing.total_qty) != 0
      ) {
        this.openMDBox = true;
      }
    },
    closeManualDiscountModal(data) {
      this.openMDBox = data;
    },
    closeCarryBagModal(data) {
      this.openBox = data;
    },
    discountAmount() {
      let data = [];
    },
    putHoldBill() {
      if (this.state.sessions.session.type == "open") {
        this.$bvModal.hide("hold-bill");
        let alertData = {
          message: msg.HOLDBILL_FAIL,
          type: "danger",
        };
        this.$showAlert = true;
        this.$store.commit("notifications/showAlert", alertData);
      } else {
        this.$loading = true;
        let postData = {
          amount: this.state.billing.billing.total_payable,
          sub_total: this.state.billing.billing.subtotal,
          discount: this.state.billing.billing.discount,
          tax_total: this.state.billing.billing.taxes,
          total: this.state.billing.billing.total_payable,
          bill_buster_discount: "",
          employee_id: "",
          employee_discount: "",
          pay_by_voucher: "",
          payment_gateway_type: "",
          bill_buster_id: "",
          temp_order_id: "",
          manual_discount_factor: "",
          manual_discount_basis: "",
          manual_discount: "",
          transaction_sub_type: "hold",
          url: "process-to-payment",
          cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
            "gstin"
          )
            ? this.state.billing.billing.customer.data.gstin
            : "",
        };
        let data = Object.assign(
          postData,
          this.essentialsData,
          this.customerData
        );
        this.$store
          .dispatch("billing/holdBill", data)
          .then((res) => {
            this.$store.dispatch("billing/cartDetails").then(() => {
              this.$loading = false;
              let alertData = {
                message:
                  res.data.status == "add_opening_balance" ||
                  res.data.status == "fail"
                    ? res.data.message
                    : msg.HOLDBILL_SUCCESS,
                type:
                  res.data.status == "add_opening_balance" ||
                  res.data.status == "fail"
                    ? "danger"
                    : "success",
              };
              this.$showAlert = true;
              this.$store.commit("notifications/showAlert", alertData);
              this.$bvModal.hide("hold-bill");
            });
          })
          .catch((err) => {
            this.$loading = false;
          });
      }
    },
    saveRemarks() {
      this.$loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.state.billing.billing.remark = this.form.remark;
        this.$loading = false;
        this.$bvModal.hide("bill-remark");
      }
    },
    checkHoldBillShortkey() {
      // let check = true;
      this.state.system.settings.cart_menu.map((item) => {
        if (item.name == "hold_bill" && item.status == 1) {
          if (this.state.billing.billing.total_qty != 0) {
            // check = false;
            this.$bvModal.show("hold-bill");
          }
        }
      });
      // return check;
    },
    showHeldBillShortkey() {
      if (this.state.billing.billing.hold_bill_count != 0) {
        this.$router.push("../held-bill");
      }
    },
    openCarryBagShortkey() {
      if (this.state.system.settings.cart.carry_bag.status != 0) {
        this.openCarryBags();
      }
    },
    openCarryBags() {
      this.$loading = true;
      let data = {
        // c_id: this.state.c_id,
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        url: "/get-carry-bags",
      };
      let postData = Object.assign(
        data,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(data.url, postData)
        .then((response) => {
          this.carryBags = response.data.data;
          //  this.carryBagsQty = carryBags.Qty;
          this.openBox = true;
          this.$loading = false;
        })
        .catch((err) => {
          this.$loading = false;
          if (err.response.data.status == "redirect_to_store_list") {
            let errorData = {
              msg: msg.LOGIN_REDIRECT,
              btntext: "Login",
              type: "logout",
            };
            this.$store.commit("notifications/showMessage", errorData);
          }
        });
    },
    applyPromotions() {
      this.$loading = true;
      let data = {
        url: "/calculate-promotions",
        cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
          "gstin"
        )
          ? this.state.billing.billing.customer.data.gstin
          : "",
      };
      let postData = Object.assign(data, this.customerData);
      axios
        .post(data.url, postData)
        .then((res) => {
          if (res.data.status == "fail") {
            let alertData = {
              message: res.data.message,
              type: "danger",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          } else {
            this.$store.commit("billing/saveCartDetails", res.data);
            this.$store.commit(
              "billing/saveHoldBillCount",
              res.data.hold_bill_count
            );
          }
          this.$loading = false;
        })
        .catch((err) => {
          this.$loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.badge {
  text-overflow: inherit !important;
}
#hold-bill header button {
  line-height: 0px;
}
.theme-dark #hold-bill ul {
  li p {
    color: #fff;
  }
}
#hold-bill ul {
  text-align: center;
  padding: 0px;
  li {
    list-style-type: none;
    padding-bottom: 10px;
    p {
      color: #404040;
    }
  }
  li + li {
    padding-bottom: 0px;
  }
}
#hold-bill button {
  padding: 0.475rem 1rem;
  width: 120px;
}
// #hold-bill .btn-danger {
//   background: #cc3333 !important;
//   border: 1px #cc3333 solid !important;
// }
.theme-dark #hold-bill .grey-outline-btn {
  border: 1px #606060 solid;
  background-color: transparent !important;
  color: #606060;
  width: 120px;
}
#hold-bill .grey-outline-btn {
  border: 1px #808080 solid;
  background-color: transparent !important;
  color: #808080;
  width: 120px;
}
#hold-bill .grey-outline-btn:focus:active {
  border: 1px #808080 solid;
  background-color: #808080 !important;
  color: #fff;
}
#hold-bill .grey-outline-btn:hover {
  border: 1px #808080 solid;
  background-color: #808080 !important;
  color: #fff;
}
.btn-grey:disabled:hover {
  opacity: 0.3 !important;
}
</style>
